import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { DissolutionEntitySelectionComponent } from '../dissolution-entity-selection/dissolution-entity-selection.component';
import { AcquisitionProposalOverviewComponent } from '../acquisition-proposal-overview/acquisition-proposal-overview.component';
import { SessionStorageService } from 'src/app/core/services/session_storage';
import { PROPOSAL_ID } from 'src/app/constants/constants';
import { NzMessageService } from 'ng-zorro-antd/message';
import { AcquisitionProposedSlateComponent } from '../acquisition-proposed-slate/acquisition-proposed-slate.component';
import { DataServiceProposalOverview } from 'src/app/core/services/data_service_proposal_overview';
import { UntypedFormGroup } from '@angular/forms';
import { formControlElement, formLabelElement } from 'src/app/animations/animations';
import { DissolutionProposalAttachmentsComponent } from '../dissolution-proposal-attachments/dissolution-proposal-attachments.component';

@Component({
    selector: 'app-dissolution-proposal-details',
    templateUrl: './dissolution-proposal-details.component.html',
    styleUrl: './dissolution-proposal-details.component.less',
    animations: [formControlElement, formLabelElement],
    standalone: false
})

export class DissolutionProposalDetailsComponent {
  @ViewChild(DissolutionEntitySelectionComponent) childAcquisitionEntitySelectionComponent!: DissolutionEntitySelectionComponent;
  @ViewChild(AcquisitionProposalOverviewComponent) childAcquisitionProposalOverviewComponent!: AcquisitionProposalOverviewComponent;
  @ViewChild(DissolutionProposalAttachmentsComponent) DissolutionProposalAttachmentsComponent!: DissolutionProposalAttachmentsComponent;
  

  @Output() isLoader = new EventEmitter<boolean>();
  @Output() selectedTabIndexEmitValue=new EventEmitter<number>();
  @Input() proposalOverviewForm!:  UntypedFormGroup;
  @Input() dissolutionEntitySelectionForm!: UntypedFormGroup;
  @Input() dissolutionProposalAttachmentForm!: UntypedFormGroup;
  
  entitySelection: string = "entity selection";
  entityQuestions: string = "entity questions";
  overview: string = "overview";
  attachments: string = "attachments";
  selectedTabTitle: string = this.entitySelection;
  @Input() entitySelectionTabClass = 'tab-default';
  @Input() summaryTabClass = 'tab-default';
  @Input() attachmentTabClass = 'tab-default';
  @Input() attachmentUploadClass="";
  @Input() selectedTabIndexValue!:number;
  proposalId!: string;
  constructor(private session: SessionStorageService, private message: NzMessageService,
    private proposalOverviewDataService: DataServiceProposalOverview){}
  ngOnInit(){
    this.isLoader.emit(false);
    //being used by html file for attachments?
    if(this.session.getItem(PROPOSAL_ID)){
      this.proposalId = this.session.getItem(PROPOSAL_ID);
    }

  }
  emitIsLoader(event:boolean){
    this.isLoader.emit(event);
  }
  async getCurrentTab(event:any){
    this.selectedTabIndexEmitValue.emit(event);
  }
  

}
